import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { MarkingColorService } from 'services/marking-color-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class MarkingColorNew {
  private markingColor: Models.MarkingColor = new Models.MarkingColor();

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private markingColorService: MarkingColorService
  ) {}

  private createMarkingColor() {
    this.markingColorService
      .post(this.markingColor)
      .then((res) => {
        this.eventAggregator.publish('markingColorListReset', 1);
        this.toastService.showSuccess('markingColor.created');
        this.router.navigateToRoute('marking-color-detail', { Id: res.Id });
      })
      .catch((err) => this.errorService.handleError(err));
  }
}
